import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { ReferenceRateUnit } from "__generated__/graphql";

const ReferenceRateUnitSelect = ({ value, onChange }: Omit<SelectProps<ReferenceRateUnit, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(ReferenceRateUnit)}
			getOptionLabel={(option) => intl.formatMessage({ id: `REFERENCE_RATE_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default ReferenceRateUnitSelect;
